import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const RefreshIcon = ({ size = 22, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 4v4h-4" />
    <path d="M21 12a9 9 0 0 1-15 6.7L3 16M3 20v-4h4" />
  </svg>
)
